"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.articleBuy = exports.articleShow = exports.ArticleType = void 0;
var axios_1 = require("axios");
var commonProperties_1 = require("./lib/commonProperties");
var config_1 = require("./config");
var ArticleType;
(function (ArticleType) {
    ArticleType["ARTICLE"] = "ARTICLE";
    ArticleType["SALE"] = "SALE";
})(ArticleType = exports.ArticleType || (exports.ArticleType = {}));
var ENDPOINT_BUY = function (baseUrl) { return baseUrl + "/Article/Buy"; };
var ENDPOINT_SHOW = function (baseUrl) { return baseUrl + "/Article/Show"; };
exports.articleShow = function (ArticleId, ProductId, BrandId, baseUrl, getCookie, setCookie, View, CatalogId, ItemType, SaleId) {
    if (ItemType === void 0) { ItemType = ArticleType.ARTICLE; }
    if (SaleId === void 0) { SaleId = null; }
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, SearchType = _a.SearchType, Integration = _a.Integration, AdId = _a.AdId, OpeningHash = _a.OpeningHash, VariantName = _a.VariantName, ModelName = _a.ModelName, Filter = _a.Filter;
    var params = {
        ItemType: ItemType,
        ArticleId: ArticleId,
        SaleId: SaleId,
        ProductId: ProductId,
        BrandId: BrandId,
        SearchCity: SearchCity,
        SearchWord: SearchWord,
        PageType: PageType,
        Platform: Platform,
        Origin: Origin,
        SearchType: SearchType,
        Integration: Integration,
        View: View,
        AdId: AdId,
        OpeningHash: OpeningHash,
        CatalogId: CatalogId,
        VariantName: VariantName,
        ModelName: ModelName,
        Filter: Filter
    };
    axios_1.default.post(ENDPOINT_SHOW(baseUrl), __assign(__assign({}, params), commonProperties_1.default(getCookie, setCookie)));
};
exports.articleBuy = function (ArticleId, ProductId, BrandId, baseUrl, getCookie, setCookie, View, CatalogId, ItemType, SaleId) {
    if (ItemType === void 0) { ItemType = ArticleType.ARTICLE; }
    if (SaleId === void 0) { SaleId = null; }
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, SearchType = _a.SearchType, Integration = _a.Integration, AdId = _a.AdId, OpeningHash = _a.OpeningHash, VariantName = _a.VariantName, ModelName = _a.ModelName, Filter = _a.Filter;
    var params = __assign({ ItemType: ItemType,
        ArticleId: ArticleId,
        SaleId: SaleId,
        ProductId: ProductId,
        BrandId: BrandId,
        SearchCity: SearchCity,
        SearchWord: SearchWord,
        PageType: PageType,
        Platform: Platform,
        Origin: Origin,
        SearchType: SearchType,
        Integration: Integration,
        View: View,
        AdId: AdId,
        OpeningHash: OpeningHash,
        CatalogId: CatalogId,
        VariantName: VariantName,
        ModelName: ModelName,
        Filter: Filter }, commonProperties_1.default(getCookie, setCookie));
    return fetch(ENDPOINT_BUY(baseUrl), {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify(params),
        keepalive: true,
    });
};
//# sourceMappingURL=article.js.map